import {
  POST_DISEASE_HEALTH,
  POST_DISEASE_SUCCESS_HEALTH,
  POST_DISEASE_FAILURE_HEALTH,
} from "../../action/Health/types/types";

const INITIAL_STATE = {
  diseaseDetails: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case POST_DISEASE_HEALTH:
      return { ...state, diseaseDetails: action.payload };
    case POST_DISEASE_SUCCESS_HEALTH:
      return { ...state, diseaseDetails: action.payload };
    case POST_DISEASE_FAILURE_HEALTH:
      return { ...state, diseaseDetails: action.payload };

    default:
      return state;
  }
};
